// extracted by mini-css-extract-plugin
export default {"Loader":"Spinner_Loader__NOLIU","rotation":"Spinner_rotation__fiD5b"};